<img [src]="src" [alt]="caption" />
<div class="field is-grouped">
  <p class="control">{{ caption }}</p>
  <button
    *ngIf="allowRetake"
    class="button is-secondary is-small control"
    (click)="retake.emit()"
    [disabled]="!src"
    translate
  >
    captioned-image.component.retake
  </button>
</div>
